import { FC } from 'react'

import './style.scss'

type DividerProps = {
  className?: string
}

const Divider:FC<DividerProps> = ({ className, ...rest })  => {
  return (
    <hr className={`divider ${className}`} {...rest} />
  )
}

export { Divider }